import * as React from 'react';
import { useEffect } from 'react';

import * as fullStory from 'js/lib/fullstory';
import { useLocation } from 'js/lib/useRouter';
import user from 'js/lib/user';

import RecruitingProfileViewerWithProviders from 'bundles/account-profile/components/RecruitingProfileViewerWithProviders';
import { shouldEnableLearnerProfileFullStory } from 'bundles/account-profile/epicFeatureFlags';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';

type QueryParams = {
  externalId?: string;
  slug?: string;
};

type PropsFromCaller = { params?: QueryParams };

type Props = PropsFromCaller;

const E2E_SELECTORS = {
  PROFILE_VIEWER_PAGE: 'profile-viewer-page',
};

export const AccountProfileViewerPage: React.FC<Props> = ({ params }) => {
  const externalId = params?.externalId;
  const slug = params?.slug;
  const userId = user.get()?.id ?? '';
  const location = useLocation();
  const isRecruitingSource = location.query.source === 'recruitingDashboard';

  useEffect(() => {
    // Source is from the recruiting dashboard, always sample
    if (isRecruitingSource) {
      fullStory.start({ disableForCourserians: true });
      fullStory.set({
        isRecruiter: true,
        employabilityAccountProfile: true,
        userId,
      });
    } else if (shouldEnableLearnerProfileFullStory()) {
      fullStory.start({ disableForCourserians: true });
      fullStory.set({
        userId,
        employabilityAccountProfile: true,
      });
    }
  }, [isRecruitingSource, userId]);

  return (
    <div data-e2e={E2E_SELECTORS.PROFILE_VIEWER_PAGE} className="rc-AccountProfileViewerPage c-phoenix-template-page">
      <PageHeader />
      <RecruitingProfileViewerWithProviders externalId={externalId} profileSlug={slug} isEditMode={false} />
      <PageFooter />
    </div>
  );
};

export default AccountProfileViewerPage;
